import React from 'react';
import { Box, Typography } from '@mui/material';
import { LinearProgressWithLabelProps } from './Progress.props';
import { StyledLinearProgress } from './ProgressBar.styles';

const LinearProgressWithLabel = (props: LinearProgressWithLabelProps) => {
  const { file } = props;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%' }}>
        <StyledLinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35, position: 'absolute', marginLeft: '2rem' }}>
        <Typography variant="body2">{file.name}</Typography>
      </Box>
    </Box>
  );
};

export default LinearProgressWithLabel;
